// extracted by mini-css-extract-plugin
module.exports = {"add-alt-btn":"QuestionModal_add-alt-btn__1s2s_","imagem":"QuestionModal_imagem__3Jfl2","alt":"QuestionModal_alt__2oUzc","correta":"QuestionModal_correta__1la75"};